// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"9136f201","136":"ec2ae807","343":"334ee530","348":"016af719","665":"18dca211","774":"90c650dc","778":"474baa49"}[chunkId] + ".chunk.css";
};